module.exports = __webpack_public_path__ + "9de1e9e82f4e782d92d89c4cc8cd5bb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/7.jpg
// module id = 1366
// module chunks = 47